/**
 * @group Network
 * @summary Network error types for categorizing errors
 * 
 * @remarks
 * This constant contains network error types used for categorizing
 * different types of network-related errors for better error handling.
 * 
 * @example
 * ```typescript
 * import { NETWORK_ERROR_TYPES } from '@shared/constants';
 * 
 * function categorizeError(error: Error): string {
 *   if (error.message.includes('timeout')) {
 *     return NETWORK_ERROR_TYPES.TIMEOUT;
 *   }
 *   if (error.message.includes('connection')) {
 *     return NETWORK_ERROR_TYPES.CONNECTION;
 *   }
 *   return NETWORK_ERROR_TYPES.UNKNOWN;
 * }
 * ```
 */
export const NETWORK_ERROR_TYPES = {
  CONNECTION: 'CONNECTION_ERROR',
  TIMEOUT: 'TIMEOUT_ERROR',
  DNS: 'DNS_ERROR',
  SSL: 'SSL_ERROR',
  RATE_LIMIT: 'RATE_LIMIT_ERROR',
  DATABASE: 'DATABASE_ERROR',
  AUTHENTICATION: 'AUTHENTICATION_ERROR',
  AUTHORIZATION: 'AUTHORIZATION_ERROR',
  VALIDATION: 'VALIDATION_ERROR',
  NOT_FOUND: 'NOT_FOUND_ERROR',
  SERVER: 'SERVER_ERROR',
} as const; 